// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__38uQu","rightAdornment":"Header_rightAdornment__1Lcj4"};